// DashboardContext.js
import React, { createContext, useContext, useState, useEffect } from 'react';

const DashboardContext = createContext();
export const useDashboardContext = () => useContext(DashboardContext);

export const DashboardProvider = ({ children }) => {
  const [conversations, setConversations] = useState(() => {
    const saved = localStorage.getItem('dashboardConversations');
    return saved ? JSON.parse(saved) : {
      main: [],
      exfac: [],
      iqvia: [],
      activity: [],
      main_with_activity: []
    };
  });

  const [chatIds, setChatIds] = useState(() => {
    const saved = localStorage.getItem('dashboardChatIds');
    return saved ? JSON.parse(saved) : {
      main: Date.now(),
      exfac: Date.now(),
      iqvia: Date.now(),
      activity: Date.now(),
      main_with_activity: Date.now()
    };
  });

  useEffect(() => {
    localStorage.setItem('dashboardConversations', JSON.stringify(conversations));
    localStorage.setItem('dashboardChatIds', JSON.stringify(chatIds));
  }, [conversations, chatIds]);

  const setConversation = (key, conv) => {
    setConversations((prev) => ({ ...prev, [key]: conv }));
  };

  const setChatId = (key, id) => {
    setChatIds((prev) => ({ ...prev, [key]: id }));
  };

  // ✅ Define the reset function
  const resetDashboardState = () => {
    setConversations({
      main: [],
      exfac: [],
      iqvia: [],
      activity: [],
      main_with_activity: []
    });
    setChatIds({
      main: Date.now(),
      exfac: Date.now(),
      iqvia: Date.now(),
      activity: Date.now(),
      main_with_activity: Date.now()
    });
    localStorage.removeItem('dashboardConversations');
    localStorage.removeItem('dashboardChatIds');
  };

  // ✅ Include it in the provider value
  return (
    <DashboardContext.Provider value={{
      conversations,
      setConversation,
      chatIds,
      setChatId,
      resetDashboardState
    }}>
      {children}
    </DashboardContext.Provider>
  );
};
